import { aiUsageFetch } from './aiUsageApi';

const API = process.env.REACT_APP_EMBROIDERY_CREDIT_BILLING_API ||
  'https://us-central1-svgtrace-pro.cloudfunctions.net/embroideryCreditBilling';

export async function creditBillingRequest(path, payload, signal) {
  const response = await aiUsageFetch(`${API}${path}`, {
    ...(payload ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) } : {}),
    signal,
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || 'Credit checkout is unavailable. Please try again.');
  return result;
}
